var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "a11y-widget",
      attrs: {
        role: "complementary",
        "aria-label": _vm.t("accessibility.tools"),
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "a11y-toggle",
          class: { "a11y-toggle--open": _vm.open },
          attrs: {
            "aria-expanded": _vm.open ? "true" : "false",
            "aria-controls": "a11y-panel",
            "aria-label": _vm.t("accessibility.openTools"),
          },
          on: { click: _vm.togglePanel },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                "aria-hidden": "true",
                focusable: "false",
                width: "20",
                height: "20",
                viewBox: "0 0 16 16",
                fill: "currentColor",
              },
            },
            [
              _c("circle", { attrs: { cx: "8", cy: "2.6", r: "1.6" } }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M3.2 5.8c0-.44.36-.8.8-.8h8c.44 0 .8.36.8.8s-.36.8-.8.8H9.6v2l2.2 4.4a.8.8 0 1 1-1.43.72L8.8 10.4h-1.6l-1.57 3.32a.8.8 0 1 1-1.43-.72L6.4 8.6v-2H4c-.44 0-.8-.36-.8-.8z",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "a11y-sr-only" }, [
            _vm._v(_vm._s(_vm.t("accessibility.toolsTitle"))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.open,
              expression: "open",
            },
          ],
          staticClass: "a11y-panel",
          class: { "a11y-panel--open": _vm.open },
          attrs: {
            id: "a11y-panel",
            role: "dialog",
            "aria-modal": "false",
            "aria-label": _vm.t("accessibility.options"),
          },
        },
        [
          _c("div", { staticClass: "a11y-panel__header" }, [
            _c("span", { staticClass: "a11y-panel__title" }, [
              _c(
                "svg",
                {
                  staticStyle: {
                    "vertical-align": "-2px",
                    "margin-right": "6px",
                  },
                  attrs: {
                    "aria-hidden": "true",
                    focusable: "false",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "currentColor",
                  },
                },
                [
                  _c("circle", { attrs: { cx: "8", cy: "2.6", r: "1.6" } }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M3.2 5.8c0-.44.36-.8.8-.8h8c.44 0 .8.36.8.8s-.36.8-.8.8H9.6v2l2.2 4.4a.8.8 0 1 1-1.43.72L8.8 10.4h-1.6l-1.57 3.32a.8.8 0 1 1-1.43-.72L6.4 8.6v-2H4c-.44 0-.8-.36-.8-.8z",
                    },
                  }),
                ]
              ),
              _vm._v("\n\t\t\t\tAccessibility Tools\n\t\t\t"),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "a11y-panel__close",
                attrs: {
                  "aria-label": _vm.t("accessibility.closePanel"),
                  title: _vm.t("common.close"),
                },
                on: { click: _vm.togglePanel },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      "aria-hidden": "true",
                      focusable: "false",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "currentColor",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M18.3 5.7a1 1 0 0 0-1.4 0L12 10.6 7.1 5.7a1 1 0 0 0-1.4 1.4l4.9 4.9-4.9 4.9a1 1 0 1 0 1.4 1.4l4.9-4.9 4.9 4.9a1 1 0 0 0 1.4-1.4L13.4 12l4.9-4.9a1 1 0 0 0 0-1.4z",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "a11y-panel__body" }, [
            _c("div", { staticClass: "a11y-section" }, [
              _c("div", { staticClass: "a11y-section__label" }, [
                _vm._v(_vm._s(_vm.t("accessibility.textSize"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "a11y-row" }, [
                _c(
                  "button",
                  {
                    staticClass: "a11y-btn",
                    attrs: {
                      disabled: _vm.fontSizeLevel <= 0,
                      "aria-label": _vm.t("accessibility.decreaseTextSize"),
                    },
                    on: { click: _vm.decreaseFontSize },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          "aria-hidden": "true",
                          focusable: "false",
                          width: "18",
                          height: "18",
                          viewBox: "0 0 24 24",
                          fill: "currentColor",
                        },
                      },
                      [
                        _c(
                          "text",
                          {
                            attrs: {
                              x: "3",
                              y: "18",
                              "font-size": "16",
                              "font-family": "sans-serif",
                            },
                          },
                          [_vm._v("A")]
                        ),
                        _c(
                          "text",
                          {
                            attrs: {
                              x: "14",
                              y: "20",
                              "font-size": "11",
                              "font-family": "sans-serif",
                            },
                          },
                          [_vm._v("-")]
                        ),
                      ]
                    ),
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.t("accessibility.smaller")) +
                        "\n\t\t\t\t\t"
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "a11y-level-indicator",
                    attrs: { "aria-live": "polite", "aria-atomic": "true" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.t(
                          "accessibility.fontSizeLevels." +
                            _vm.fontSizeLabels[_vm.fontSizeLevel]
                        )
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "a11y-btn",
                    attrs: {
                      disabled:
                        _vm.fontSizeLevel >= _vm.fontSizeSteps.length - 1,
                      "aria-label": _vm.t("accessibility.increaseTextSize"),
                    },
                    on: { click: _vm.increaseFontSize },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          "aria-hidden": "true",
                          focusable: "false",
                          width: "18",
                          height: "18",
                          viewBox: "0 0 24 24",
                          fill: "currentColor",
                        },
                      },
                      [
                        _c(
                          "text",
                          {
                            attrs: {
                              x: "2",
                              y: "18",
                              "font-size": "16",
                              "font-family": "sans-serif",
                            },
                          },
                          [_vm._v("A")]
                        ),
                        _c(
                          "text",
                          {
                            attrs: {
                              x: "14",
                              y: "20",
                              "font-size": "11",
                              "font-family": "sans-serif",
                            },
                          },
                          [_vm._v("+")]
                        ),
                      ]
                    ),
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.t("accessibility.larger")) +
                        "\n\t\t\t\t\t"
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "a11y-section" }, [
              _c("div", { staticClass: "a11y-section__label" }, [
                _vm._v(_vm._s(_vm.t("accessibility.visual"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "a11y-grid" }, [
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.highContrast },
                    attrs: {
                      "aria-pressed": _vm.highContrast ? "true" : "false",
                      "aria-label": _vm.t("accessibility.toggleHighContrast"),
                    },
                    on: { click: _vm.toggleHighContrast },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "a11y-tile__icon a11y-tile__icon--contrast",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("◑")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.highContrast"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.invertColors },
                    attrs: {
                      "aria-pressed": _vm.invertColors ? "true" : "false",
                      "aria-label": _vm.t("accessibility.toggleInvertColors"),
                    },
                    on: { click: _vm.toggleInvertColors },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "a11y-tile__icon",
                        staticStyle: { filter: "invert(1)" },
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("☀")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.invertColors"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.grayscale },
                    attrs: {
                      "aria-pressed": _vm.grayscale ? "true" : "false",
                      "aria-label": _vm.t("accessibility.toggleGrayscale"),
                    },
                    on: { click: _vm.toggleGrayscale },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "a11y-tile__icon",
                        staticStyle: { filter: "grayscale(1)" },
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("🎨")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.grayscale"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.highlightLinks },
                    attrs: {
                      "aria-pressed": _vm.highlightLinks ? "true" : "false",
                      "aria-label": _vm.t("accessibility.toggleHighlightLinks"),
                    },
                    on: { click: _vm.toggleHighlightLinks },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "a11y-tile__icon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("🔗")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.highlightLinks"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.bigCursor },
                    attrs: {
                      "aria-pressed": _vm.bigCursor ? "true" : "false",
                      "aria-label": _vm.t("accessibility.toggleBigCursor"),
                    },
                    on: { click: _vm.toggleBigCursor },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "a11y-tile__icon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("🖱")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.bigCursor"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.focusHighlight },
                    attrs: {
                      "aria-pressed": _vm.focusHighlight ? "true" : "false",
                      "aria-label": _vm.t("accessibility.toggleFocusHighlight"),
                    },
                    on: { click: _vm.toggleFocusHighlight },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "a11y-tile__icon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("⌨")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.focusHighlight"))),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "a11y-section" }, [
              _c("div", { staticClass: "a11y-section__label" }, [
                _vm._v(_vm._s(_vm.t("accessibility.reading"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "a11y-grid" }, [
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.dyslexiaFont },
                    attrs: {
                      "aria-pressed": _vm.dyslexiaFont ? "true" : "false",
                      "aria-label": _vm.t("accessibility.toggleDyslexiaFont"),
                    },
                    on: { click: _vm.toggleDyslexiaFont },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "a11y-tile__icon",
                        staticStyle: {
                          "font-family": "Arial,sans-serif",
                          "font-weight": "bold",
                          "font-size": "1.2em",
                        },
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("Aa")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.dyslexiaFont"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.lineHeight },
                    attrs: {
                      "aria-pressed": _vm.lineHeight ? "true" : "false",
                      "aria-label": _vm.t("accessibility.toggleLineSpacing"),
                    },
                    on: { click: _vm.toggleLineHeight },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "a11y-tile__icon",
                        staticStyle: {
                          "line-height": "1",
                          "font-size": "1.1em",
                        },
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("≡")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.lineSpacing"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.textSpacing },
                    attrs: {
                      "aria-pressed": _vm.textSpacing ? "true" : "false",
                      "aria-label": _vm.t("accessibility.toggleTextSpacing"),
                    },
                    on: { click: _vm.toggleTextSpacing },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "a11y-tile__icon",
                        staticStyle: {
                          "letter-spacing": "3px",
                          "font-size": "0.9em",
                        },
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("A B")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.textSpacing"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.pauseAnimations },
                    attrs: {
                      "aria-pressed": _vm.pauseAnimations ? "true" : "false",
                      "aria-label": _vm.t(
                        "accessibility.togglePauseAnimations"
                      ),
                    },
                    on: { click: _vm.togglePauseAnimations },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "a11y-tile__icon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("⏸")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.pauseAnimations"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.readingGuide },
                    attrs: {
                      "aria-pressed": _vm.readingGuide ? "true" : "false",
                      "aria-label": _vm.t("accessibility.toggleReadingGuide"),
                    },
                    on: { click: _vm.toggleReadingGuide },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "a11y-tile__icon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("📖")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.readingGuide"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "a11y-tile",
                    class: { "a11y-tile--active": _vm.hideImages },
                    attrs: {
                      "aria-pressed": _vm.hideImages ? "true" : "false",
                      "aria-label": _vm.t("accessibility.toggleHideImages"),
                    },
                    on: { click: _vm.toggleHideImages },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "a11y-tile__icon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("🖼")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "a11y-tile__text" }, [
                      _vm._v(_vm._s(_vm.t("accessibility.hideImages"))),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "a11y-section",
                staticStyle: {
                  "border-top": "1px solid #e5e7eb",
                  "padding-top": "10px",
                  "margin-top": "4px",
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "a11y-reset-btn",
                    attrs: { "aria-label": _vm.t("accessibility.resetAria") },
                    on: { click: _vm.resetAll },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t↺ " +
                        _vm._s(_vm.t("accessibility.resetAll")) +
                        "\n\t\t\t\t"
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "a11y-panel__footer" }, [
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.t("accessibility.savedNote")) + "\n\t\t"
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.readingGuide
        ? _c("div", {
            staticClass: "a11y-reading-guide",
            style: { top: _vm.guideY + "px" },
            attrs: { "aria-hidden": "true" },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }